import { SQUARE_ASPECTS_STRING } from '@anm/data/aspects';

import { TemplatePage } from './types';

const trendingPage: TemplatePage = {
  header: {
    color: '#FDB7AF',
    icon: 'images/video-templates/trending.jpg',
    title: 'Trending Video Templates',
    title_meta: '500+ Customizable Trending Video Templates',
    description_meta:
      'Take your video marketing to the next level with Wave.video’s collections of high-quality trending video templates.',
    description:
      'Take your video marketing to the next level with Wave.video’s collections of high-quality trending video templates. ' +
      'Customizable and free!'
  },
  footer: {
    category: 'Trending',
    description:
      'With Wave.video’s collections of trending video templates, you won’t need to hire a high-end graphic designer to make ' +
      'appealing video content for your brand. Just pick a template that suits your needs best, customize it for your business, ' +
      'and download or share directly on social media. Easy as one-two-three!'
  },
  content: [
    {
      type: 'slider',
      name: 'use-cases-animated',
      title: 'Animated Video Templates',
      search: {
        name: 'animated',
        tags: 'animated',
        aspects: SQUARE_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      name: 'use-cases-frame',
      title: 'Frame Video Templates',
      search: { name: 'frame', tags: 'frame', aspects: SQUARE_ASPECTS_STRING }
    },
    {
      type: 'slider',
      name: 'use-cases-collage',
      title: 'Collage Video Templates',
      search: {
        name: 'collage',
        tags: 'collage',
        aspects: SQUARE_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      name: 'holidays',
      title: 'Holiday Video Templates',
      search: {
        category: '/Holidays & Occasions/Holiday Season',
        aspects: SQUARE_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      title: 'intro & outro',
      name: 'use-cases-intro-outro',
      search: {
        category: '/Use Cases/Intro & Outro',
        aspects: SQUARE_ASPECTS_STRING
      }
    },

    {
      type: 'stocks',
      title: 'Trending',
      search: { name: 'trending' }
    },
    {
      type: 'calendar'
    }
  ]
};

export default trendingPage;
